import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { JobSelectionDialogComponent } from './job-selection-dialog/job-selection-dialog.component'
import { UiLibraryModule } from '../ui-library/ui-library.module'
import { SharedModule } from '../shared/shared.module'
import { PipelineSelectionComponent } from './job-selection-dialog/pipeline-selection/pipeline-selection.component'
import { AutoSegmentationSelectionComponent } from './job-selection-dialog/auto-segmentation-selection/auto-segmentation-selection.component'
import { CustomSegmentationSelectionComponent } from './job-selection-dialog/custom-segmentation-selection/custom-segmentation-selection.component'
import { NucleusExpansionSelectionComponent } from './job-selection-dialog/nucleus-expansion-selection/nucleus-expansion-selection.component'
import { GenericRegistrationSelectionComponent } from './job-selection-dialog/registration-selection/generic-registration-selection/generic-registration-selection.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { IntensitySelectionComponent } from './job-selection-dialog/intensity-selection/intensity-selection.component'
import { JobStatusDialogComponent } from './job-status-dialog/job-status-dialog.component'
import { JobStatusGroupComponent } from './job-status-dialog/job-status-group/job-status-group.component'
import { LetDirective } from '@ngrx/component'
import { RegistrationSelectionComponent } from './job-selection-dialog/registration-selection/registration-selection.component'
import { RecurrentNeighborhoodsSelectionComponent } from './job-selection-dialog/recurrent-neighborhoods-selection/recurrent-neighborhoods-selection.component'
import { ClusteringSelectionComponent } from './job-selection-dialog/clustering-selection/clustering-selection.component'
import { TsneSelectionComponent } from './job-selection-dialog/clustering-selection/tsne-clustering-selection/tsne-selection.component'
import { UmapSelectionComponent } from './job-selection-dialog/clustering-selection/umap-clustering-selection/umap-selection.component'
import { MarkerSelectionComponent } from './job-selection-dialog/clustering-selection/marker-clustering-selection/marker-selection.component'
import { NeighborhoodEnrichmentSelectionComponent } from "./job-selection-dialog/neighborhood-enrichment-selection/neighborhood-enrichment-selection.component";
import { SelectLayersDialogComponent } from './job-selection-dialog/auto-segmentation-selection/select-layers-dialog/select-layers-dialog.component'
import { LayerListDialogComponent } from './job-selection-dialog/custom-segmentation-selection/layer-list-dialog/layer-list-dialog.component'

@NgModule({
    declarations: [
        JobSelectionDialogComponent,
        PipelineSelectionComponent,
        AutoSegmentationSelectionComponent,
        CustomSegmentationSelectionComponent,
        NucleusExpansionSelectionComponent,
        GenericRegistrationSelectionComponent,
        IntensitySelectionComponent,
        JobStatusDialogComponent,
        JobStatusGroupComponent,
        RegistrationSelectionComponent,
        RecurrentNeighborhoodsSelectionComponent,
        NeighborhoodEnrichmentSelectionComponent,
        ClusteringSelectionComponent,
        TsneSelectionComponent,
        UmapSelectionComponent,
        MarkerSelectionComponent,
        SelectLayersDialogComponent,
        LayerListDialogComponent,
    ],
    imports: [
        CommonModule,
        UiLibraryModule,
        SharedModule,
        FormsModule,
        LetDirective,
        ReactiveFormsModule,
    ],
    exports: [JobSelectionDialogComponent, JobStatusDialogComponent],
})
export class JobsModule {}
